import { Skeleton } from "@mui/material";
import useTitanApp from "@/hooks/useTitanApp";

export default function ConsultationSettingsSkeleton() {
  const { appState } = useTitanApp();
  const { darkMode } = appState;
  const isDarkMode = darkMode;

  const skeletonSx = { bgcolor: isDarkMode ? "grey.800" : "grey.300" };

  const mockTemplates = Array(5).fill(null);

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <Skeleton
            animation="wave"
            variant="text"
            width={200}
            height={28}
            sx={skeletonSx}
            className="mb-1"
          />
          <Skeleton
            animation="wave"
            variant="text"
            width={320}
            height={20}
            sx={skeletonSx}
          />
        </div>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={140}
          height={36}
          className="rounded"
          sx={skeletonSx}
        />
      </div>

      {/* Tabs */}
      <div className={`border-b ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
        <nav className="flex -mb-px space-x-8">
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={180}
            height={40}
            className="rounded-t"
            sx={skeletonSx}
          />
        </nav>
      </div>

      {/* Filters */}
      <div className="flex gap-4">
        <div className="flex-1">
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={40}
            className="rounded"
            sx={skeletonSx}
          />
        </div>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={192}
          height={40}
          className="rounded"
          sx={skeletonSx}
        />
      </div>

      {/* Templates Grid */}
      <div className="space-y-3">
        {mockTemplates.map((_, index) => (
          <div
            key={index}
            className={`border rounded-lg p-4 transition-all duration-300 ${
              isDarkMode
                ? "border-gray-700 bg-gray-800"
                : "border-gray-200 bg-white"
            }`}
          >
            <div className="flex items-center justify-between">
              {/* Left Section - Template Info */}
              <div className="flex items-center gap-4 flex-1">
                {/* Icon and Name */}
                <div className="flex items-center gap-3">
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={20}
                    height={20}
                    sx={skeletonSx}
                  />
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={180}
                        height={24}
                        sx={skeletonSx}
                      />
                      {index === 0 && ( // Only show badge for first item (Default)
                        <Skeleton
                          animation="wave"
                          variant="rectangular"
                          width={50}
                          height={20}
                          className="rounded"
                          sx={skeletonSx}
                        />
                      )}
                    </div>
                    <Skeleton
                      animation="wave"
                      variant="text"
                      width={280}
                      height={16}
                      sx={skeletonSx}
                    />
                  </div>
                </div>

                {/* Category Badge */}
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  width={80}
                  height={24}
                  className="rounded-full"
                  sx={skeletonSx}
                />

                {/* Template Stats */}
                <div className="flex items-center gap-6 text-xs ml-auto">
                  <div className="flex items-center gap-1">
                    <Skeleton
                      animation="wave"
                      variant="circular"
                      width={12}
                      height={12}
                      sx={skeletonSx}
                    />
                    <Skeleton
                      animation="wave"
                      variant="text"
                      width={40}
                      height={16}
                      sx={skeletonSx}
                    />
                  </div>
                  <div className="flex items-center gap-1">
                    <Skeleton
                      animation="wave"
                      variant="circular"
                      width={12}
                      height={12}
                      sx={skeletonSx}
                    />
                    <Skeleton
                      animation="wave"
                      variant="text"
                      width={80}
                      height={16}
                      sx={skeletonSx}
                    />
                  </div>
                </div>
              </div>

              {/* Right Section - Actions */}
              <div className="flex items-center gap-2">
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={32}
                  height={32}
                  sx={skeletonSx}
                />
                {index !== 0 && ( // Don't show delete for first item (Default)
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={32}
                    height={32}
                    sx={skeletonSx}
                  />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
